import React, { useEffect, useRef, useState } from 'react';

interface UpdateEstimatedDaysInShopModalProps {
  isOpen: boolean;
  currentValue?: number | null;
  onCancel: () => void;
  onConfirm: (days: number) => void;
  sidebarRef?: React.RefObject<HTMLDivElement>;
}

const normalizeEstimatedDays = (value?: number | null): number => {
  if (typeof value !== 'number' || Number.isNaN(value) || value < 0) {
    return 0;
  }

  return value;
};

const UpdateEstimatedDaysInShopModal: React.FC<UpdateEstimatedDaysInShopModalProps> = ({
  isOpen,
  currentValue = 0,
  onCancel,
  onConfirm,
  sidebarRef,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [estimatedDays, setEstimatedDays] = useState<number>(() => normalizeEstimatedDays(currentValue));

  useEffect(() => {
    setEstimatedDays(normalizeEstimatedDays(currentValue));
  }, [currentValue]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const clickedNode = event.target as Node;
      const isOutsideModal = modalRef.current && !modalRef.current.contains(clickedNode);
      const isOutsideSidebar = sidebarRef?.current && !sidebarRef.current.contains(clickedNode);

      if (isOutsideModal && isOutsideSidebar) {
        onCancel();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onCancel, sidebarRef]);

  if (!isOpen) return null;

  const handleConfirm = (e: React.FormEvent) => {
    e.preventDefault();
    onConfirm(estimatedDays);
  };

  return (
    // `.status-modal-overlay` já fica um nível acima do modal de ações (shared/ui/modal-overlay.css).
    <div className="status-modal-overlay">
      <div className="status-modal-content" ref={modalRef}>
        <div className="LightboxStatus">
          <form className="LightboxStatusForm">
            <div className="EditarCarro">Alterar previsão de dias na esteira</div>
            <div className="CampoStatus">
              <div className="DropDownFormulRioStatus">
                <div className="InputSelect">
                  <input
                    type="text"
                    className="Input"
                    value={String(estimatedDays)}
                    onChange={(e) => {
                      const onlyDigits = e.target.value.replace(/\D/g, '');
                      setEstimatedDays(Number(onlyDigits || 0));
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="Frame1000003998Status">
              <div className="CtaBigEditar cancel" onClick={onCancel}>
                <button className="CustomFileCancel" type="button">
                  Cancelar
                </button>
              </div>
              <button
                onClick={handleConfirm}
                className="CtaBigEditar save"
                type="button"
              >
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateEstimatedDaysInShopModal;
